import React, { Component } from 'react'
import PropTypes from 'prop-types'
import SavedSearchesResult from '../../../../../../../components/ui/SavedSearches/SavedSearchesResult'
import searches from '../../../../../../../utils/routing/searches'

class SavedCareerSearchesWrapper extends Component {
  static propTypes = {
    onDelete: PropTypes.func.isRequired,
    careerSearches: PropTypes.array.isRequired,
  }

  render() {
    const { onDelete, careerSearches } = this.props
    return (
      <div>
        {careerSearches.map(searchItem => (
          <SavedSearchesResult
            key={searchItem._id}
            createdAt={searchItem.createdAt}
            id={searchItem._id}
            label={`${searchItem.searchParams.search_query}
               ${searchItem.searchParams.company ? ' - ' : ''}
               ${
                 searchItem.searchParams.company
                   ? searchItem.searchParams.company
                   : ''
               }
            `}
            linkTo={searches.buildUrlForSavedResumeSearch({
              searchParams: {
                searchType: 'career',
                search_query: searchItem.searchParams.search_query,
                company: searchItem.searchParams.company ? searchItem.searchParams.company : '',
                state: searchItem.searchParams.state ? searchItem.searchParams.state : [],
              },
            })}
            onDelete={onDelete}
          />
        ))}
      </div>
    )
  }
}

export default SavedCareerSearchesWrapper



// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/routes/Career/components/SavedCareerSearches/savedCareerSearchesWrapper.js